import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class FloatingScrollTrigger {
  constructor(elms) {
    this.dom = { elms: elms };
    this.dom.parent = document.querySelector('[data-js="floating"]');

    this.startMoveY = 0;
    this.endMoveY = 0;

    this.easing = 'slow(0.7,0.7,false)';

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    [...this.dom.elms].forEach((el, index) => {
      this.startMoveY = `${33.333 * index}`;
      this.endMoveY = `${33.333 * (index + 1)}`;
      gsap.fromTo(this.dom.parent,
        {
          yPercent: -this.startMoveY,
        },
        {
          // y: `${-100 * (index + 1)}vh`,
          yPercent: -this.endMoveY,
          delay: 0,
          duration: .3,
          ease: this.easing,
          scrollTrigger: {
            trigger: el,
            id: index + 1,
            start: 'top-=0 50%',
            end: 'bottom-=0 100%',
            toggleActions: 'play none none reset',
            markers: false,
            scrub: 1.2,
          },
          // onComplete: ()=>{
          //   console.log(index, this.endMoveY)
          // }
        }
      )
      this.dom.parent.removeAttribute('style');
    });
  }
}

export default FloatingScrollTrigger;
